import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useScorecentreOptions } from '~SpectateStore/hooks/scoreboardHooks';
import { useVisualizationProvider } from '~SpectateStore/hooks/eventsHooks';
import SportRadarVisualization from './SportRadarVisualization';
import BetGeniusVisualization from './BetGeniusVisualization';
import './styles/scoreboard.scss';

const FeedVisualization = ({ eventId, updateStatusCallback }) => {
    const provider = useVisualizationProvider(eventId);
    const scorecentreOptions = useScorecentreOptions();
    const [visualizationComponent, setVisualizationComponent] = useState(<></>);

    useEffect(() => {
        if (Object.keys(scorecentreOptions).length > 0) {
            const feedProps = {
                eventId,
                updateStatusCallback,
            };

            if (provider === 'BG') {
                setVisualizationComponent(<BetGeniusVisualization {...feedProps} />);
            }

            if (provider === 'BR') {
                setVisualizationComponent(<SportRadarVisualization {...feedProps}/>);
            }
        }
    }, [scorecentreOptions]);

    return visualizationComponent;
};

FeedVisualization.propTypes = {
    eventId: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.number.isRequired,
    ]),
    updateStatusCallback: PropTypes.func,
};

export default FeedVisualization;
